module.exports = __webpack_public_path__ + "static/img/xwv.2fe0d0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xwv.jpg
// module id = Lj6U
// module chunks = 1